import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformResiliencePage from '@src/pages/Platform/Resilience';

export const Route = createLazyFileRoute('/platform/resilience')({
  component: PlatformResiliencePageWithLayout,
});

function PlatformResiliencePageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformResiliencePage />
    </DefaultLayout>
  );
}
